import { render, staticRenderFns } from "./Merkmal.vue?vue&type=template&id=f67a51b4&scoped=true&"
import script from "./Merkmal.vue?vue&type=script&lang=js&"
export * from "./Merkmal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67a51b4",
  null
  
)

export default component.exports